function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

$(document).ready(function(){
  if($(window).width() > 767){
    // $("[data-menu-drawer-toggle]").hover(function(){
    //   $(".sidebar-container").show();
    // });
    $(".sidebar-container .js-enabled button").click(function(){
      $(".sidebar-container").hide();
    });
    $("[data-menu-drawer] nav ul li button").hover(function(){
      $("[data-menu-drawer] nav ul li").removeClass("active");
      $(".sidebar-container").addClass("accordion-open");
      $(".menu-drawer__accordion").hide();
      $("[data-menu-drawer] nav ul li button").attr("aria-expanded", "false");
      $(this).parent().addClass("active");
      // $(this).attr("aria-expanded", "true");
      // var id = $(this).attr("aria-controls");
      // $("#"+id+".menu-drawer__accordion").show();
    });
    $("[data-menu-drawer] nav ul li a.not-dropdown").hover(function(){
      $("[data-menu-drawer] nav ul li").removeClass("active");
      $(".sidebar-container").removeClass("accordion-open");
      $(".menu-drawer__accordion").hide();
      $("[data-menu-drawer] nav ul li button").attr("aria-expanded", "false");
    });
  }else{
    $(".header__menu-toggle button").click(function(){
      $(".sidebar-container").show();
    });
    $("[data-menu-drawer] nav ul li a.custom-country-icon").click(function(){
      $(".sidebar-container").hide();
    });
    $(".sidebar-container .js-enabled button").click(function(){
      $(".sidebar-container").hide();
      $("[data-menu-drawer] nav ul li .menu-drawer__accordion").addClass("hide").removeClass("active");
    });
    $("[data-menu-drawer] nav ul li button").click(function(){
      $(".sidebar-container").addClass("accordion-open");
      $("[data-menu-drawer] nav ul li .menu-drawer__accordion").addClass("hide").removeClass("active");
      $("[data-menu-drawer] nav ul li button").attr("aria-expanded", "false");
      $(this).attr("aria-expanded", "true");
      var id = $(this).attr("aria-controls");
      $("#"+id+".menu-drawer__accordion").removeClass("hide").addClass("active");
    });
    $(".menu-drawer__accordion-title").click(function(){
      $(".sidebar-container").removeClass("accordion-open");
      $("[data-menu-drawer] nav ul li .menu-drawer__accordion").addClass("hide").removeClass("active");
      $("[data-menu-drawer] nav ul li button").attr("aria-expanded", "false");
    });
  }

  $(".sidebar-container [data-cart-drawer-toggle]").click(function(){
    $(this).parent().find("button").trigger("click");
  });

  $(".menu-drawer__country").click(function(){
    $(".sidebar-container").hide();
    $(".header__icons .custom-country-icon").trigger("click");
    $(".custom-country-container").removeAttr("inert");
    $(".custom-country-container").removeAttr("aria-hidden");
  });

  $(".store-name input").change(function(){
    $(".drawer__stores .store-item").removeClass("active");
    if(this.checked){
      $(this).parents(".store-item").addClass("active");
      var store_name = $(this).parent().find("label").text();
      $(".store-location__button .text").text(store_name);
    }else{
      $(this).parents(".store-item").removeClass("active");
    }
  });

  $(".store-details").click(function(){
    $(".drawer__header-back").text("back");
    
    var store = $(this).data('store');
    $(".store-locator-drawer .drawer__content").hide();
    $(".drawer__store-details").hide();
    $("#drawer__store-"+store).show();
  });

  $(".drawer__header-back").click(function(){
    $(".drawer__header-back").text(" ");
    $(".drawer__store-details").hide();
    $(".store-locator-drawer .drawer__content").show();
  });

  $(".drawer__location-current .btn-change").click(function(){
    $(this).parent().hide();
    $(".drawer__location-dropdow").css("display", "grid");

    var country_handle = $(".drawer__location-dropdow .country-dropdown select").val().toLowerCase().replace(" ", "-");
      $(".city-dropdown select").hide();
      $(".city-dropdown select#country-"+country_handle).show();
    
    $(".drawer__location-dropdow .country-dropdown select").change(function(){
      var country_handle = $(this).val().toLowerCase().replace(" ", "-");
      $(".city-dropdown select").hide();
      $(".city-dropdown select#country-"+country_handle).show();
    });
  });

  $(".image-with-text-section .grid").click(function(){
    $(this).find("a").get('0').click();
  });

  // $('.product-images__slider').slick({
  //   dots: true,
  //   arrows: true,
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   prevArrow: '<div class="arrow-left"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_1232_3828" fill="white"><path d="M0 10.6064L10.6066 -0.000158012L21.2132 10.6064L10.6066 21.213L0 10.6064Z"/></mask><path d="M0 10.6064L-1.41421 9.19223L-2.82843 10.6064L-1.41421 12.0207L0 10.6064ZM1.41421 12.0207L12.0208 1.41406L9.19239 -1.41437L-1.41421 9.19223L1.41421 12.0207ZM12.0208 19.7988L1.41421 9.19223L-1.41421 12.0207L9.19239 22.6273L12.0208 19.7988Z" fill="black" mask="url(#path-1-inside-1_1232_3828)" /></svg></div>',
  //   nextArrow: '<div class="arrow-right"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_1232_3827" fill="white"><path d="M21.2109 10.6064L10.6043 21.213L-0.00226557 10.6064L10.6043 -0.000156224L21.2109 10.6064Z"/></mask><path d="M21.2109 10.6064L22.6252 12.0207L24.0394 10.6064L22.6252 9.19223L21.2109 10.6064ZM19.7967 9.19223L9.19012 19.7988L12.0185 22.6273L22.6252 12.0207L19.7967 9.19223ZM9.19012 1.41406L19.7967 12.0207L22.6252 9.19223L12.0185 -1.41437L9.19012 1.41406Z" fill="black" mask="url(#path-1-inside-1_1232_3827)"/></svg></div>'
  // });

  $(".image-with-text-overlay-section").click(function(){
    $(this).find("a").get(0).click();
  });
  $(".video-with-text-overlay-section").click(function(){
    $(this).find("a").get(0).click();
  });

  $('.custom-image-with-text-wrapper button').trigger('click');
});

$(document).mouseup(function(e){
    var container = $(".store-locator-drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $("body").removeClass("store-locator-drawer__open");
      container.removeClass("open");
    }
});
